type ThumbChangeOptions = {
  isMaxChangeOnly?: boolean;
  isMinChangeOnly?: boolean;
};

export const getChangedThumbOptions = (
  previousValues: Array<number>,
  nextValues: Array<number>,
): ThumbChangeOptions => {
  const didMinChange = previousValues[0] !== nextValues[0];
  const didMaxChange = previousValues[1] !== nextValues[1];

  if (didMinChange && !didMaxChange) {
    return { isMinChangeOnly: true };
  }

  if (didMaxChange && !didMinChange) {
    return { isMaxChangeOnly: true };
  }

  return {};
};
